import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import classes from 'js/components/pipelines/cards/QueryPrompt/QueryPrompt.module.scss';
import { has } from 'lodash';
import { QueryPrompt } from 'js/components/pipelines/cards/QueryPrompt';
import { QueryRewriter } from 'js/components/pipelines/cards/QueryRewriter';
import { ContextEnricher } from 'js/components/pipelines/cards/ContextEnricher';
import { LLMProcessor } from 'js/components/pipelines/cards/LLMProcessor';
import { DataRetriever } from 'js/components/pipelines/cards/DataRetriever';
import { QueryResponse } from 'js/components/pipelines/cards/QueryResponse';
import { Reranker } from 'js/components/pipelines/cards/Reranker';

interface RAGNodeProps {
  data: any;
}

const RagNodes = {
  query_prompt: QueryPrompt,
  query_rewriter: QueryRewriter,
  data_retriever_holder: DataRetriever,
  context_enricher: ContextEnricher,
  llm_processor: LLMProcessor,
  query_response: QueryResponse,
  reranker: Reranker,
};

export const RAGNode = memo((props: RAGNodeProps) => {
  const { data } = props;
  const { item, layoutDirection = 'LR' } = data;

  const { key, isSecondaryFlow, ...restData } = data;

  const sourcePosition =
    layoutDirection === 'TB'
      ? Position.Bottom
      : layoutDirection === 'RL'
        ? Position.Left
        : Position.Right;
  const targetPosition =
    layoutDirection === 'TB'
      ? Position.Top
      : layoutDirection === 'RL'
        ? Position.Right
        : Position.Left;

  if (isSecondaryFlow) {
    return null;
  }

  if (!item) {
    return <div />;
  }

  let children;
  if (has(item, 'children') && item.children.length) {
    children = item.children;
  }

  const Node = RagNodes[item.node_type];

  const cardProps = {
    ...props,
    cardData: item,
    data: item,
  };

  return (
    <div>
      {children && (
        <Handle
          isConnectable={false}
          className={item.node_type !== 'context_enricher' ? classes.handle : ''}
          type="source"
          position={sourcePosition}
          id="right"
        />
      )}
      {item.type !== 'SOURCE' && (
        <Handle
          isConnectable={false}
          className={classes.handle}
          type="target"
          position={targetPosition}
          id="left"
        />
      )}

      {item.type === 'DATA_SINK' &&
        !!item.children?.length &&
        item.node_type === 'query_response' && (
          <Handle
            isConnectable={false}
            className={classes.handle}
            type="source"
            position={sourcePosition}
            id="right"
          />
        )}

      {item.type === 'DATA_SINK' &&
        !!item.children?.length &&
        item.node_type !== 'query_response' && (
          <Handle
            isConnectable={false}
            className={classes.handle}
            type="source"
            position={sourcePosition}
            id="bottom"
          />
        )}
      <Node {...cardProps} />
    </div>
  );
});
